<template>
    <v-container>
            <v-card class="mb-1" >
                <v-card-title>สร้างใบสั่งซ่อม</v-card-title>
                <v-card-text>
                    <v-form >
                        <v-row >
                            <v-col>
                                <v-text-field small disabled  v-model="job.jobNo"  label="เลขที่ใบสั่งซ่อม"  placeholder=" " outlined></v-text-field>
                            </v-col>
                            <v-col>
                                <v-text-field small disabled  v-model="job.jobDate"   label="วันที่ใบสั่งซ่อม"  placeholder=" " outlined></v-text-field>
                            </v-col>
                            <v-col>
                                <v-text-field small disabled  v-model="job.appointDate"  label="วันที่นัดหมาย"  placeholder=" " outlined></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-text-field small disabled  v-model="job.jobSize"  label="ประเภทงาน"  placeholder=" " outlined></v-text-field>
                            </v-col>
                            <v-col>
                                <v-text-field disabled  v-model="job.empContact" label="เจ้าหน้าที่รับรถ"  placeholder=" " outlined></v-text-field>
                            </v-col>

                            <v-col>
                                <v-text-field disabled small  v-model="job.licenseNo"  label="ทะเบียนรถ"  placeholder=" " outlined></v-text-field>
                            </v-col>
                            <v-col>
                                <v-text-field class="estimateNo" autofocus v-model="bpe.estimateNo" maxlength="20" :disabled="!canEdit" :rules="[rules.required]"  label="เลขที่ใบประเมิน"  placeholder=" " outlined></v-text-field>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
            </v-card>
            <v-card class="mb-1">
                <v-card-title> ข้อมูลงานซ่อม 
                    <v-spacer></v-spacer>
                    
                    </v-card-title>
                <v-card-text class="mb-2">
                    <BpeHeader ref="bpeHeader" @setBpeHeader="setBpeHeader" 
                        :canEdit="disableHeader" :branchCode="branchCode"></BpeHeader>
                    <v-expansion-panels  v-model="panel" multiple>

                        <v-expansion-panel key="serviceDetail" class="mb-1">
                            <v-expansion-panel-header>รายละเอียดงานซ่อม</v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <BpeServiceDetail ref="bpeService" 
                                key="bpeServiceCnt"
                                @syncBpeServiceDetail="setBpeServiceDetail" 
                                :discount="bpeHeader.laborDiscount"
                                :currentItems="bpeServiceDetail"
                                :canEdit="canEdit"></BpeServiceDetail>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel key="serviceParts" class="mb-1">
                            <v-expansion-panel-header>รายการอะไหล่</v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <BpeServiceParts ref="bpeParts" 
                                    @syncBpeParts="setBpeParts" 
                                    :discount="bpeHeader.partDiscount"
                                    :brandCode="brandCode"
                                    :currentItems="bpeParts"
                                    :canEdit="canEdit">
                                </BpeServiceParts>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-spacer ></v-spacer>
                        <v-expansion-panel key="external" class="mb-1">
                            <v-expansion-panel-header>รายการงานนอก</v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <BpeExternal ref="bpeExternal"
                                    @syncBpeExternal="setBpeExternal" 
                                    :currentItems="bpeExternal"
                                    :canEdit="canEdit"
                                ></BpeExternal>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel key="invoice">
                            <v-expansion-panel-header>รายการใบแจ้งหนี้</v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <BpeInvoice ref="bpeInvoice"
                                    :items="bpeInvoice"
                                ></BpeInvoice>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-card-text>
                
            </v-card>

            <v-card>
                <v-card-title>สรุปยอด</v-card-title>
                <v-card-text>
                     <v-row>
                        <v-col cols="6">
                            <v-data-table
                            :headers="headerSummary"
                            :items="itemSummary"
                            style="border:0.2px solid; border-color:#909090"
                            hide-default-footer
                            >
                            </v-data-table>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-spacer></v-spacer>
                    </v-row>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn v-if="parseInt(job.jobStatusCode) <= '10'" class="ma-2" color="primary" @click="save">บันทึก</v-btn>
                    <v-btn v-if="parseInt(job.jobStatusCode) <= '10'" class="ma-2" color="primary" @click="closeDialog"> ยกเลิก</v-btn>
                    <v-btn v-else class="ma-2" color="primary" @click="closeDialog"> ปิด</v-btn>
                </v-card-actions>
            </v-card>
    </v-container>
</template>

<style scoped>
    .estimateNo {
        align-content: center;
    }
</style>

<script>
import BpeHeader from './BpeHeader'
import BpeServiceDetail from './BpeServiceDetail'
import BpeServiceParts from './BpeServiceParts'
import BpeExternal from './BpeExternal'
import BpeInvoice from './BpeInvoice'
import rules from '@/assets/js/rules.js'
import {formatDate, parseDate} from '@/assets/js/common.js'
import dialog from '@/assets/js/dialog.js'
import numeral from 'numeral'

export default {
    name: 'Bpe',
    props: ["job", "branchCode"],
    components: {
        BpeHeader,
        BpeServiceDetail,
        BpeServiceParts,
        BpeExternal,
        BpeInvoice
    },
    computed: {
        disableHeader() {
            return this.canEdit || !this.isEmptyDetail();
        },
        brandCode() {
            return this.job.brandCode == undefined ? this.job.car.brandCode : this.job.brandCode;
        }
    },
    data: () => ({
        panel:[0, 1, 2],
        canEdit: false,
        dialog: false,
        headerSummary: [
            {text: '', value: 'type'},
            {text: 'ยอดรวม', value: 'totalDisplay'},
            {text: 'ส่วนลด', value: 'discountDisplay'},
            {text: 'ราคารวมสุทธิ', value: 'grandTotalDisplay'}
        ],
        itemSummary: [],
        rules: rules,
        bpe: {
            estimateNo: '',
            invoiceNo: '',
            invoiceDate: '',
            dirty: false
        },
        bpeHeader: {
            jobType: '1',
            discount: 0
        },
        bpeServiceDetail: [],
        bpeParts: [],
        bpeExternal: [],
        bpeInvoice: [],
        summary: {
            default: {
                total: 0,
                totalDisplay: '0',
                discount: 0,
                discountDisplay: '0',
                grandTotal: 0,
                grandTotalDisplay: '0'
            },
            service: {
                type: 'ค่าแรง',
                total: 0,
                totalDisplay: '0',
                discount: 0,
                discountDisplay: '0',
                grandTotal: 0,
                grandTotalDisplay: '0'
            },
            parts: {
                type: 'ค่าอะไหล่',
                total: 0,
                totalDisplay: '0',
                discount: 0,
                discountDisplay: '0',
                grandTotal: 0,
                grandTotalDisplay: '0'
            },
            total: {
                type: 'รวม',
                total: 0,
                totalDisplay: '0',
                discount: 0,
                discountDisplay: '0',
                grandTotal: 0,
                grandTotalDisplay: '0'
            },
            tax: {
                type: 'ภาษี 7%',
                total: 0,
                totalDisplay: '0',
                discount: 0,
                discountDisplay: '0',
                grandTotal: 0,
                grandTotalDisplay: '0'
            },
            grandTotal: {
                type: 'รวมทั้งสิ้น',
                total: 0,
                totalDisplay: '0',
                discount: 0,
                discountDisplay: '0',
                grandTotal: 0,
                grandTotalDisplay: '0'
            },
            external: {
                type: 'งานนอก',
                total: 0,
                totalDisplay: '0',
                discount: 0,
                discountDisplay: '0',
                grandTotal: 0,
                grandTotalDisplay: '0'
            },
            bpeServiceCnt: 0
        }
    }),
    methods: {
        calculateSummaryAllType() {
            this.calulateSummaryType(this.bpeServiceDetail, this.summary.service);
            this.calulateSummaryType(this.bpeParts, this.summary.parts);
            this.calulateSummaryType(this.bpeExternal, this.summary.external);
        },
        calculateSummary() {
            this.summary.total.total = parseFloat(this.summary.service.total) + parseFloat(this.summary.parts.total);
            this.summary.total.discount = parseFloat(this.summary.service.discount) + parseFloat(this.summary.parts.discount);
            this.summary.total.grandTotal = parseFloat(this.summary.service.grandTotal) + parseFloat(this.summary.parts.grandTotal);
            this.summary.total.totalDisplay = numeral(this.summary.total.total).format('0,0.00');
            this.summary.total.discountDisplay = numeral(this.summary.total.discount).format('0,0.00');
            this.summary.total.grandTotalDisplay = numeral(this.summary.total.grandTotal).format('0,0.00');


            this.summary.tax.total = parseFloat(this.summary.total.total) * 7 / 100;
            this.summary.tax.discount = parseFloat(this.summary.total.discount) * 7 / 100;
            this.summary.tax.grandTotal = parseFloat(this.summary.total.grandTotal) * 7 / 100;

            this.summary.tax.totalDisplay = numeral(this.summary.tax.total).format('0,0.00');
            this.summary.tax.discountDisplay = numeral(this.summary.tax.discount).format('0,0.00');
            this.summary.tax.grandTotalDisplay = numeral(this.summary.tax.grandTotal).format('0,0.00');

            this.summary.grandTotal.total = parseFloat(this.summary.total.total) + parseFloat(this.summary.tax.total);
            this.summary.grandTotal.discount = parseFloat(this.summary.total.discount) + parseFloat(this.summary.tax.discount);
            this.summary.grandTotal.grandTotal = parseFloat(this.summary.total.grandTotal) + parseFloat(this.summary.tax.grandTotal);

            this.summary.grandTotal.totalDisplay = numeral(this.summary.grandTotal.total).format('0,0.00');
            this.summary.grandTotal.discountDisplay = numeral(this.summary.grandTotal.discount).format('0,0.00');
            this.summary.grandTotal.grandTotalDisplay = numeral(this.summary.grandTotal.grandTotal).format('0,0.00');
        },
        calulateSummaryType(items, summary) {
            let tmp = Object.assign({}, this.summary.default);
            items.forEach(element => {
                tmp.total += parseFloat(element.total);
                tmp.discount += parseFloat(element.discountPrice);
                tmp.grandTotal += parseFloat(element.grandTotal);
            });
            
            summary.total = tmp.total;
            summary.totalDisplay = numeral(summary.total).format('0,0.00');
            summary.discount = tmp.discount;
            summary.discountDisplay = numeral(summary.discount).format('0,0.00');
            summary.grandTotal = tmp.grandTotal;
            summary.grandTotalDisplay = numeral(summary.grandTotal).format('0,0.00');
            this.calculateSummary();
        },
        extractData() { // extract data from job to bpe component
            if (this.bpe.jobType != '1') {
                this.bpe.insuranceCode = '';
                this.bpe.insuranceName = '';
                this.bpe.insuranceType = '';
            }
            if (!this.bpe.laborDiscount) {
                this.bpe.laborDiscount = 0;
            }
            if (!this.bpe.partDiscount) {
                this.bpe.partDiscount = 0;
            }
            this.bpeHeader.jobType = this.bpe.jobType;
            this.bpeHeader.insCode = this.bpe.insuranceCode;
            this.bpeHeader.insName = this.bpe.insuranceName;
            this.bpeHeader.insType = this.bpe.insuranceType;
            this.bpeHeader.laborDiscount = this.bpe.laborDiscount;
            this.bpeHeader.partDiscount = this.bpe.partDiscount;
            this.bpeHeader.policyNo = this.bpe.policyNo;
            this.bpeHeader.acidentNo = this.bpe.acidentNo;
            this.bpeServiceDetail = this.bpe.serviceList;
            this.bpeParts = this.bpe.partsList;
            this.bpeExternal = this.bpe.externalList;
            this.bpeInvoice = this.bpe.invoiceList;
            this.$refs.bpeHeader.setHeader(this.bpeHeader);
            
            this.bpeServiceDetail.forEach((e, no) => {
                e.seq = no + 1;
                this.$refs.bpeService.setDisplay(e);
            });

            this.bpeParts.forEach((e, no) => {
                e.no = no + 1;
                this.$refs.bpeParts.setDisplay(e);
            });

            this.bpeExternal.forEach((e, no) => {
                e.no = no + 1;
                this.$refs.bpeExternal.calulateDiscount(e);
            });

            if (this.bpeInvoice) {
                this.bpeInvoice.forEach((e, no) => {
                    e.no = no + 1;
                });
            }
            
            this.calculateSummaryAllType();
        },
        combineData() {
            this.bpe.jobType = this.bpeHeader.jobType;
            this.bpe.insuranceCode = this.bpeHeader.insCode;
            this.bpe.insuranceName = this.bpeHeader.insName;
            this.bpe.insuranceType = this.bpeHeader.insType;
            this.bpe.laborDiscount = this.bpeHeader.laborDiscount;
            this.bpe.partDiscount = this.bpeHeader.partDiscount;
            this.bpe.policyNo = this.bpeHeader.policyNo;
            this.bpe.acidentNo = this.bpeHeader.acidentNo;
            this.bpe.modify = formatDate(new Date().toISOString().substr(0, 10));
            this.bpe.createBy = this.$store.getters.getUser;

            this.bpe.serviceList = this.bpeServiceDetail;
            this.bpe.partsList  = this.bpeParts;
            this.bpe.externalList = this.bpeExternal;

            this.bpe.transCount = this.bpe.serviceList.length;
            //this.bpe.transAmount = parseFloat(this.summary.grandTotal.grandTotal) + parseFloat(this.summary.external.grandTotal);
            this.bpe.transAmount = parseFloat(this.summary.total.grandTotal);
        },
        isEmptyDetail() {
            return (this.bpeServiceDetail == undefined || this.bpeServiceDetail.length == 0) &&
                (this.bpeParts == undefined || this.bpeParts.length == 0) &&
                (this.bpeExternal == undefined || this.bpeExternal.length == 0);
        },
        save() {
            if (!this.$refs.bpeHeader.validate() || !this.bpe.estimateNo) {
                dialog.warn('กรุณากรอกเลขที่ใบประเมิน', () => {
                    let el = this.$el.getElementsByClassName("estimateNo")[0];
                    el.scrollIntoView();
                    el.focus();
                });
                return;
            }
            if (this.isEmptyDetail()) {
                dialog.warn('กรุณาเพิ่มข้อมูลงานซ่อม อย่างน้อย 1 รายการ');
                return;
            }
            this.combineData();
            this.bpe.dirty = true;
            this.$emit("setBpe", this.bpe);

            this.closeDialog(true);
        },
        closeDialog(isSave) {
            this.clearData();
            this.$emit("closeDialog", isSave);
        },
        clearData() {
            this.$refs.bpeHeader.clearData();
            if (this.$refs.bpeService) {
                this.$refs.bpeService.clearData();
            }
            if (this.$refs.bpeParts) {
                this.$refs.bpeParts.clearData();
            }

            this.bpe = Object.assign({}, {});
            this.bpeHeader = Object.assign({}, {});
            this.bpeServiceDetail = Object.assign([], []);
            this.bpeParts = Object.assign([], []);
            this.bpeExternal = Object.assign([], []);

            this.summary.service = Object.assign(this.summary.service, this.summary.default);
            this.summary.total = Object.assign(this.summary.total, this.summary.default);
            this.summary.parts = Object.assign(this.summary.parts, this.summary.default);
            this.summary.tax = Object.assign(this.summary.tax, this.summary.default);
            this.summary.grandTotal = Object.assign(this.summary.grandTotal, this.summary.default);
            this.summary.external = Object.assign(this.summary.external, this.summary.default);
        },
        setBpeHeader(header) {
            this.bpeHeader = header;
            this.$refs.bpeService.setDiscount(header.laborDiscount);
            this.$refs.bpeParts.setDiscount(header.partDiscount);
            //let brand = (this.job.brandCode == undefined ? this.job.car.brandCode : this.job.brandCode);
            let brand = this.job.car.brandCode;
            this.$refs.bpeParts.loadDropdown(brand);
        },
        setBpeServiceDetail(details) {
            this.bpeServiceDetail = details;
            this.calulateSummaryType(details, this.summary.service);
            this.bpeServiceCnt++;
        },
        setBpeParts(bpeParts) {
            this.bpeParts = bpeParts;
            this.calulateSummaryType(bpeParts, this.summary.parts);
        },
        setBpeExternal(bpeExternal) {
            this.bpeExternal = bpeExternal;
            this.calulateSummaryType(bpeExternal, this.summary.external);
        },
        setBpeData(bpeData) {
            this.bpe = bpeData;
            if (this.$refs.invoiceDate) {
                this.$refs.invoiceDate.setDate(parseDate(this.bpe.invoiceDate));
            }
            
        },
        setCanEdit(canEdit) {
            this.canEdit = canEdit;
        },
        onShow(isNew) {
            if (isNew) {
                this.$refs.bpeHeader.setHeader();
            } else {
                this.extractData();
            }
           // this.panel = [];
        }
    },
    mounted() {
        this.itemSummary.push(this.summary.service);
        this.itemSummary.push(this.summary.parts);
        this.itemSummary.push(this.summary.total);
        this.itemSummary.push(this.summary.tax);
        this.itemSummary.push(this.summary.grandTotal);
        this.itemSummary.push(this.summary.external);
    }
}
</script>